(function (window, $, Argument, app) {
    var Array = window.Array;
    var console = window.console;
    var actions = {};
    var hrefRegex = /[-\/\\^$*+?.()|[\]{}=&]/g;

    function ActionResolver() {
        var _this = this;

        var getValue = function ($el) {
            var value = $el.val();

            if (! value && $el.attr('href')) {
                var href = $el.attr('href') || '';
                
                value = href.replace(/^#/, '').replace(hrefRegex, '\\$&');
            }

            if (! value) {
                value = $el.data('value') || $el.data('val') || $el;
            }

            return value;
        };

        var getRel = function ($el) {
            var rel = $el.attr('rel');

            if (! rel) {
                rel = $el.data('rel');
            }

            if (typeof rel === 'string') {
                return rel.replace(/^#/, '').replace(hrefRegex, '\\$&');
            }

            return rel;
        };

        var resolveAction = function (action, params) {
            params = Argument.get(params, []);

            if (actions[action]) {
                return actions[action].apply(app, params);
            }

            var matches = action.match(/([A-Z][A-z0-9_-]*)\.([a-z][A-z0-9_-]*)/);

            if (! matches) {
                throw new app.Exception('InvalidActionException', 'The action "' + action + '" is not a valid action string.');
            }

            var Module = app[matches[1]];

            if (typeof Module !== 'object') {
                throw new app.Exception('InvalidActionException', 'The Module "' + matches[1] + '" does not exist within the ' + app.NAME + ' Application.');
            }

            var method = Module[matches[2]];

            if (typeof method !== 'function') {
                throw new app.Exception('InvalidActionException', 'The method "' + matches[2] + '" does not exist within the Module "' + matches[1] + '".');
            }

            return method.apply(Module, params);
        };

        this.registerAction = function (name, action) {
            actions[name] = action;
        };

        this.exec = function () {
            var result;
            var params = Array.prototype.slice.call(arguments);
            var name = params.shift();

            try {
                result = resolveAction(name, params);
            } catch (e) {
                if (! (e instanceof app.Exception)) {
                    throw e;
                }

                console.error(e.name + ': ' + e.message);
            }

            return typeof result === 'undefined' ? true : result;
        };

        this.bindActions = function () {
            app.$body.on('click', '[data-action]:not(form)', function (evt) {
                var $this = $(this);
                var params = [];
                var value = getValue($this);
                var rel = getRel($this);
                var data = $.extend({}, $this.data());
                var action = data.action;
                var result;

                if ($this.data('prevent-default') !== false) {
                    evt.preventDefault();
                }

                if (rel) {
                    params.push(rel);
                }

                if (value) {
                    params.push(value);
                }

                delete data.action;
                delete data.value;
                delete data.val;
                delete data.rel;
                params.push(data);

                try {
                    result = resolveAction(action, params);
                } catch (e) {
                    if (! (e instanceof app.Exception)) {
                        throw e;
                    }

                    console.error(e.name + ': ' + e.message);
                }

                return typeof result === 'undefined' ? true : result;
            });

            app.$body.find('input[data-change], textarea[data-change], select[data-change]').on('change paste', function () {
                var $this = $(this);
                var $group = $([]);
                var params = [];

                if ($this.is('[type="checkbox"]') || $this.is('[type="radio"]')) {
                    var name = $this.attr('name');

                    $group = app.$body.find('input[name="' + name + '"]');
                }

                if ($this.is('[type="checkbox"]')) {
                    $group.filter(':checked').each(function () {
                        params.push($(this).val());
                    });
                } else if ($this.is('[type="radio"]')) {
                    params.push($group.filter(':checked').val());
                } else {
                    params.push($this.val());
                }

                try {
                    resolveAction($this.data('change'), params);
                } catch (e) {
                    console.error(e.name + ': ' + e.message);
                }
            });
        };
    }

    app.ActionResolver = new ActionResolver();
})(window, jQuery, Argument, app);
